import { Pipe, PipeTransform } from '@angular/core';
import { getAppLocale } from '../utils/localized-date.util';

@Pipe({
  name: 'ordinalDate'
})
export class OrdinalDatePipe implements PipeTransform {

  transform(value: string, includeTime: boolean = true): string {
    const date = new Date(value);
    const now = new Date();
    const locale = getAppLocale();
    const isEnglish = locale === 'en';
    const suffixes = ['th', 'st', 'nd', 'rd'];
    let options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric' };
    let timeString = '';

    // Check if the date is 'Today' or 'Yesterday'
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const dateValue = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    // If includeTime is true, format the time part
    if (includeTime) {
      const timeOptions: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric', hour12: isEnglish ? true : undefined };
      const timeFormatter = new Intl.DateTimeFormat(isEnglish ? 'en-US' : locale, timeOptions);
      timeString = timeFormatter.format(date);
    }

    const relative = dateValue.getTime() === today.getTime() ? 0 : dateValue.getTime() === yesterday.getTime() ? -1 : null;
    if (relative !== null) {
      let label = relative === 0 ? 'Today' : 'Yesterday';
      if (!isEnglish) {
        const word = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(relative, 'day');
        label = word.charAt(0).toLocaleUpperCase(locale) + word.slice(1);
      }
      return `${label}${includeTime ? ', ' + timeString : ''}`;
    }

    // If the date is not in the current year, include the year in the format
    if (date.getFullYear() !== now.getFullYear()) {
      options.year = 'numeric';
    }

    if (!isEnglish) {
      const localized = new Intl.DateTimeFormat(locale, options).format(date);
      return localized + (includeTime ? ', ' + timeString : '');
    }

    const dtFormat = new Intl.DateTimeFormat('en-US', options);
    let formattedDate = dtFormat.format(date);
    const day = date.getDate();
    const relevantDigits = (day < 30) ? day % 20 : day % 30;
    const suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];

    // Append the ordinal suffix to the day
    formattedDate = formattedDate.replace(/(\d+)(th|st|nd|rd)?/, `$1${suffix}`);

    return formattedDate + (includeTime ? ', ' + timeString : '');
  }

}
